module.exports = __webpack_public_path__ + "img/utra_midas.925ffc18.jpg";